/**
 * parseResourceUrl - функція для парсингу URL ресурсу
 * 
 * Витягнута з UniversalResourcePageStore для використання без MobX
 */

import { resourceManager } from '@/Core/Managers/Resource'
import type { IResourceConfig } from '@/Core/Contracts/UI/Resource'

export interface ParsedUrlInfo {
    resourceConfig: IResourceConfig | null
    action: 'list' | 'view'  // Тільки list та view мають URL
    resourceId?: string | undefined
    displayMode: 'page' | 'drawer' | 'modal'
}

/**
 * Парсить URL та визначає ресурс, дію та режим відображення
 */
export function parseResourceUrl(pathname: string, isProgrammaticNav: boolean): ParsedUrlInfo {
    // Знаходимо ресурс
    let resourceConfig: IResourceConfig | null = null
    let action: ParsedUrlInfo['action'] = 'list'
    let resourceId: string | undefined = undefined

    // Перебираємо всі ресурси і шукаємо відповідність по pageUrl
    const resources = resourceManager.getAll()
    
    for (const [_key, config] of Object.entries(resources)) {
        const resConfig = config as IResourceConfig
        if (!resConfig.pageUrl) continue

        // Перевіряємо чи pathname починається з pageUrl ресурсу
        if (pathname.startsWith(resConfig.pageUrl)) {
            resourceConfig = resConfig
            
            // Визначаємо action (тільки list та view)
            const remainingPath = pathname.slice(resConfig.pageUrl.length)
            const remainingSegments = remainingPath.split('/').filter(Boolean)
            
            if (remainingSegments.length === 0) {
                action = 'list'
            } else if (remainingSegments.length === 1) {
                // Тільки view - create не має URL
                action = 'view'
                resourceId = remainingSegments[0]
            }
            // Edit та create не мають URL - відкриваються через drawer/modal
            
            break
        }
    }

    // Визначаємо displayMode
    let displayMode: 'page' | 'drawer' | 'modal' = 'page'
    
    if (action !== 'list' && resourceConfig) {
        // 1. Якщо це НЕ програмна навігація (пряме посилання) - перевіряємо конфігурацію
        if (!isProgrammaticNav) {
            // Отримуємо режим з конфігурації ресурсу
            const modeConfig = resourceConfig?.detailConfig?.modeConfig?.[action]
            const generalMode = resourceConfig?.detailConfig?.mode
            
            displayMode = modeConfig?.displayMode || generalMode || 'page'
        } else {
            // Програмна навігація - завжди page (карточка відкривається через OpenResourceCardTask)
            displayMode = 'page'
        }
    }

    return {
        resourceConfig,
        action,
        resourceId,
        displayMode,
    }
}
